import { loadElementLazyImage } from './helpers/lazy-load'
import { breakpointUp } from './helpers/breakpoints'
import { startLocoScroll, updateLocoScroll } from './locomotive-scroll'



$(document).ready(function() {

  $('.js-play-video').click(function (){
    let video = $(this).parent().find('video')
    loadElementLazyImage(video)
    $(this).fadeOut()
  })

})


